import { useMutation } from '@apollo/client'
import { Box, FormModal, Link, Text } from '@chaine/keychaine'
import React, { useState } from 'react'
import { SubmitHandler } from 'react-hook-form'

import { Toast } from '../../../_shared/components/toast'
import { validations } from '../../../_utils/validations/validations'
import { AppModalProps } from '../components/apps-data'
import { ENABLE_RMIS_APP } from '../data/mutations'

/**
 * Enables the RMIS app for Chaine.
 * @param props.app the app
 * @param props.isOpen sets the modal to open or closed
 * @param props.onClose closes the modal
 */
const RMISAppModal = React.memo((props: AppModalProps) => {
  const { isOpen, onClose, appType, app } = props
  const [formError, setFormError] = useState('')

  const { showToast } = Toast()

  const [enableRMISApp, { loading: enableAppLoading }] = useMutation(ENABLE_RMIS_APP, {
    onCompleted: () => {
      showToast({ status: 'success', title: 'RMIS App Enabled' })
      onClose()
    },
    onError: (error) => {
      showToast({ status: 'error', title: error.message })
    }
  })

  const footer = (
    <Box>
      <Text color="red.600">{formError}</Text>
      <Text>
        {`See `}
        <Link color="blue.600" href={app.docs} target="_blank" rel="noopener noreferrer">
          detailed steps here.
        </Link>
      </Text>
    </Box>
  )

  type FieldValues = { clientID?: string; domainName?: string; rmisPassword?: string }
  const handleSaveDetails: SubmitHandler<FieldValues> = (event) => {
    const { domainName, clientID, rmisPassword } = event

    enableRMISApp({
      variables: { appType: appType, clientID, domainName: domainName || undefined, password: rmisPassword }
    })
  }

  const closeModal = () => {
    setFormError('')
    onClose()
  }
  return (
    <>
      <FormModal
        isOpen={isOpen}
        onClose={closeModal}
        title={`Enable ${appType} for Chaine`}
        subtitle={`RMIS integration requires an API Client ID and Client Password. This can be requested from your RMIS rep.`}
        formSubmitHandler={handleSaveDetails}
        buttonText={'Enable'}
        initialValues={{}}
        validations={validations}
        isLoading={enableAppLoading}
        footer={footer}
        modalItems={[
          {
            labelText: 'RMIS API Client ID',
            name: 'clientID',
            placeHolder: 'Enter your RMIS Client ID',
            type: 'input'
          },
          {
            labelText: 'RMIS API Client Password',
            name: 'rmisPassword',
            placeHolder: 'Enter your RMIS Client Password',
            type: 'input'
          },
          {
            labelText: `RMIS Domain Name if you have one, otherwise leave blank.
            (YourDomainName.rmissecure.com`,

            name: 'domainName',
            placeHolder: 'Enter your RMIS Domain Name',
            type: 'input'
          }
        ]}
      />
    </>
  )
})

RMISAppModal.displayName = 'RMISApp'

export { RMISAppModal }
